import type WpiBase from "./wpi.base.ts";
import {print} from "../config.ts";

export default class WpiDefault implements WpiBase {
  constructor() {
  }

  async version(): Promise<string | null> {
    const ua = navigator.userAgent;

    // Edge (Chromium)
    let m = ua.match(/Edg\/(\d+(\.\d+)*)/);
    if (m) return `Edge ${m[1]}`;

    // Opera
    m = ua.match(/OPR\/(\d+(\.\d+)*)/);
    if (m) return `Opera ${m[1]}`;

    // Firefox
    m = ua.match(/Firefox\/(\d+(\.\d+)*)/);
    if (m) return `Firefox ${m[1]}`;

    // Safari (주의: Safari는 보통 Version/x.y.z 가 진 짜 버전)
    if (/Safari\//.test(ua) && !/Chrome\//.test(ua) && !/Chromium\//.test(ua)) {
      m = ua.match(/Version\/(\d+(\.\d+)*)/);
      return `Safari ${m ? m[1] : "Unknown"}`;
    }

    // Chrome
    m = ua.match(/Chrome\/(\d+(\.\d+)*)/);
    if (m) return `Chrome ${m[1]}`;

    return `Unknown ${ua}`;
  }

  notification(title: string, content: string, subtitle?: string): void {
    print(title, content, subtitle ?? 'empty subtitle');
  }

  media_session(title: string, artist: string, album: string, image: string): void {
    print('WpiDefault.media_session', title, artist, album, image);
  }

  // 2025-12-15 추가 메소드
  media_uri(file: string): string|null {
    print('WpiDefault.media_uri', file);
    return null;
  }

  media_save(file: string, length: string, url: string): boolean {
    print('WpiDefault.media_save', file, length, url);
    return false;
  }

  media_delete(file: string): boolean {
    print('WpiDefault.media_delete', file);
    return true;
  }

  save_begin(key: string, len: number): void {
    print('WpiDefault.save_begin', key, len);
  }

  save_chunk(key: string, index: number, _: string): void {
    print('WpiDefault.save_chunk', key, index);
  }

  save_end(key: string): void {
    print('WpiDefault.save_end', key);
  }

  network_check(fn: string, server: string): void {
    print('WpiDefault.network_check', fn, server);
  }
}